import React from "react";

import logo from "../assets/logo.svg";

const Hero = () => (
  <div className="text-center hero my-5">
    
    <h1 className="mb-4">In2 - Test Authentication Page</h1>

    <p className="lead">
      This is a sample application that demonstrates an authentication flow for
      an In2 SPA
    </p>
  </div>
);

export default Hero;
